import { render } from "./ContractConfig.vue?vue&type=template&id=cef64770&ts=true"
import script from "./ContractConfig.vue?vue&type=script&lang=ts"
export * from "./ContractConfig.vue?vue&type=script&lang=ts"

import "./ContractConfig.vue?vue&type=style&index=0&id=cef64770&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__